import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ISidebarItem } from "../Routes";
import "../../scss/sidebar.scss";
import SecondaryList from "./SecondaryList";

import { ListItemSkeleton } from "../ui/ListItemSkeleton";

interface ISideBarListItemProps {
  item: ISidebarItem;
  index: number;
  setMobileOpen: (active: boolean) => void;
  nested: boolean;
  disabledRoutes: string[];
  selected: string;
  isLoading?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      "&:hover .sidebar-icon": {
        opacity: 1,
      },
    },
    nested: {},
    sidebarSelection: {
      width: "4px",
      borderRadius: "6px",
      height: "1rem",
      margin: "0 8px 0 10px",
      backgroundColor: "transparent",
      transform: "translate(-9px)",
      transition: "0.25s ease-in-out",
      "&.selected": { backgroundColor: theme.palette.primary.main },
    },
    divider:{
      background: "#E8EAF4",
      borderRadius: "8px",
      height:"1px",
      margin:"2.0625rem 16px 1.25rem 16px"
    }
  })
);

function isKeyDisabled(key: string, arrayOfDisabledKeys: string[]) {
  if (arrayOfDisabledKeys.indexOf(key) > -1) {
    return true;
  }
  return false;
}

function SideBarListItem({
  item,
  index,
  setMobileOpen,
  nested,
  disabledRoutes,
  selected,
  isLoading = false,
}: ISideBarListItemProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const isDisabled = isKeyDisabled(item.key, disabledRoutes);
  const isOpenNewItem = item.key==="OPEN_ORDERS" || item.key==="NEW_ORDERS";
  const className = clsx(classes.wrapper, {
    [classes.nested]: nested,
  });

  const listItem = (
    <>
    <ListItem disabled={isDisabled} key={index} className={className}>
      <div
        className={`navigation__menu-item ${
          selected === item.key ? "selected" : ""
        }`}
      >
        {(item.icon && !isOpenNewItem) ? (
          <ListItemIcon className="sidebar-icon">
            {isLoading ? (
              <Skeleton
                variant="circle"
                width={20}
                height={20}
                animation="wave"
              />
            ) : (
              item.icon
            )}
          </ListItemIcon>
        ) : (
          <div
            className={`${classes.sidebarSelection} ${
              selected === item.key ? "selected" : ""
            }`}
          ></div>
        )}
        <ListItemText
          primary={
            isLoading ? (
              <Skeleton variant="text" height={25} animation="wave" />
            ) : (
              t(item.text)
            )
          }
        />
      </div>
    </ListItem>
    {item.key === "ORDER_HISTORY" && <div className={classes.divider}/>}
    </>
  );

  if (isDisabled) {
    return listItem;
  }

  return (
    <>
    {
      isOpenNewItem ? 
      isLoading?  <ListItemSkeleton totalItems={1} />:<SecondaryList
      item={item}
      isLoading={isLoading}
      selected={selected}
    />:
    <Link
      to={item.url || ""}
      onClick={() => {
        if (!isDisabled && !isLoading) {
          setMobileOpen(false);
        }
      }}
      id={item.text}
      data-component-name={item.key}
    >
      {listItem}
    </Link>
    }
    </>
  );
}

export default SideBarListItem;
